const ONE_MB_IN_BYTES: number = 1024 * 1024;

export const FILE_ATTACHMENT_TYPE: string = 'FileAttachment:#Exchange';
export const ITEM_ATTACHMENT_TYPE: string = 'ItemAttachment:#Exchange';
export const ITEM_ID_ATTACHMENT_TYPE: string = 'ItemIdAttachment:#Exchange';
export const REFERENCE_ATTACHMENT_TYPE: string = 'ReferenceAttachment:#Exchange';
export const LINK_ATTACHMENT_TYPE: string = 'LinkAttachment:#Exchange';

export const BOX = 'Box';
export const DROPBOX = 'Dropbox';
export const FACEBOOK = 'Facebook';
export const GDRIVE = 'GDrive';
export const MAILBOX = 'Mailbox';
export const MAIL_MESSAGE = 'MailMessage';
export const ONE_DRIVE_CONSUMER = 'OneDriveConsumer';
export const ONE_DRIVE_PRO = 'OneDrivePro';
export const RECENT_ATTACHMENTS = 'RecentAttachments';
export const WOPI = 'Wopi';
export const WOPI_BOX = 'WopiBox';
export const WOPI_DROPBOX = 'WopiDropbox';
export const WOPI_EGNYTE = 'WopiEgnyte';

export const MAX_SIZE_FOR_GENERATING_THUMBNAIL_IN_BYTES: number = 10 * ONE_MB_IN_BYTES;

export const AttachmentConstants = {
    providers: {
        BOX: BOX,
        DROPBOX: DROPBOX,
        FACEBOOK: FACEBOOK,
        GDRIVE: GDRIVE,
        MAILBOX: MAILBOX,
        ONE_DRIVE_CONSUMER: ONE_DRIVE_CONSUMER,
        ONE_DRIVE_PRO: ONE_DRIVE_PRO,
        RECENT_ATTACHMENTS: RECENT_ATTACHMENTS,
        WOPI: WOPI,
        WOPI_BOX: WOPI_BOX,
        WOPI_EGNYTE: WOPI_EGNYTE,
    },
    attachmentTypes: {
        FILE_ATTACHMENT_TYPE: FILE_ATTACHMENT_TYPE,
        ITEM_ATTACHMENT_TYPE: ITEM_ATTACHMENT_TYPE,
        ITEM_ID_ATTACHMENT_TYPE: ITEM_ID_ATTACHMENT_TYPE,
        REFERENCE_ATTACHMENT_TYPE: REFERENCE_ATTACHMENT_TYPE,
        LINK_ATTACHMENT_TYPE: LINK_ATTACHMENT_TYPE,
    },
};
